import { Observable, Subject } from 'rxjs'

// Subject for clicking on the schedule option select box.
const openScheduleOptionsSubject: Subject<void> = new Subject<void>()

// Observable for when clicking on the schedule option select box.
export const openSchedule$: Observable<void> = openScheduleOptionsSubject.asObservable()

// Announce when the schedule option select is clicked.
export const announceScheduleOpen = (): void => openScheduleOptionsSubject.next()
